import { cart, pubsub } from '@services';

class FreeShippingBar extends HTMLElement {
  unsubscribers = [];

  static {
    cart.sections.push('fetch-free-shipping-bar');
  }

  connectedCallback() {
    ['cart:add', 'cart:update', 'cart:change'].forEach((event) =>
      this.unsubscribers.push(
        pubsub.subscribe(event, ({ sections }) => this.renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  renderSection(sections) {
    const html = new DOMParser().parseFromString(sections['fetch-free-shipping-bar'], 'text/html');
    const target = html.querySelector('free-shipping-bar');

    this.innerHTML = target.innerHTML;
  }
}

customElements.define('free-shipping-bar', FreeShippingBar);
